import type { FC } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import PageTitle from "app/components/React/PageTitle/PageTitle";

import { useMonitorAndProtectCurrentCampaign } from "../services/api/campaign";
import { durationFilterConfigItem } from "../shared/components/navbar-filters/filter-items/duration";

import { SelectCampaignDropdown } from "./components/campaign-selector/monitor-and-protect-select-campaign";
import { locationsFilterConfigItem } from "./components/navbar-filters/filter-items/locations";
import { deviceFilterConfigItem } from "./components/navbar-filters/filter-items/web-source";
import { FiltersBar } from "./components/navbar-filters/FiltersBar";
import { useMonitorAndProtectDataAndParams } from "./hooks/navigations";
import { PageHeader } from "./ui/layout/page-header";

const TopLeftComponent = () => {
    return (
        <Flex
            paddingX="16px"
            gap="8px"
            alignItems="center"
        >
            <SelectCampaignDropdown />
        </Flex>
    );
};

export const MonitorAndProtectSubNav: FC = () => {
    const routeParams = useMonitorAndProtectDataAndParams();
    const { data, isError, isLoading } = useMonitorAndProtectCurrentCampaign();
    const currentCampaignLoaded = !isError && !!data && !isLoading;
    // const [showEducationIcon, showEducationBar, setValues] = educationHook();

    // const onEducationIconClick = () => {
    //     setValues(false, true);
    // };
    // const onCloseEducationBar = () => {
    //     setValues(true, false);
    // };

    if (!routeParams.showHeader) {
        return null;
    }

    return (
        <PageHeader
            topLeftComponent={<TopLeftComponent />}
            bottomLeftComponent={currentCampaignLoaded ? <PageTitle /> : null}
            bottomRightComponent={
                currentCampaignLoaded ? (
                    <FiltersBar
                        filters={[durationFilterConfigItem, locationsFilterConfigItem, deviceFilterConfigItem]}
                    />
                ) : null
            }
        />
    );
};
